@if (graphs.isLoading()) {
<p>Loading graphs...</p>
} @else if (graphs.error()) {
<p role="alert">Failed to load graphs</p>
} @else {
@let files = graphs.value() ?? [];
@if (files.length === 0) {
<p>No graphs found</p>
} @else if (printView()) {
<lib-print-a11-template>
  @for (file of files; track file.id) {
  <lib-view-graph [graph]="file"></lib-view-graph>
  }
</lib-print-a11-template>
} @else {
@for (file of files; track file.id) {
<lib-view-graph [graph]="file"></lib-view-graph>
}
}
}
